import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useMemo,
} from "react";
import LogUtils from "../../../../../libs/LogUtils";
import { useParams } from "react-router";
import QuestionIncludeFields from "./QuestionIncludeFields.component";
import { OutlineButton } from "../../../../../components/Buttons/PrimaryButton";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";

const TEMP_OBJ = {
  reward_points: "",
  question: "",
  description: "",
  question_images: null,
  options: [
    {
      quest_id: 0,
      is_correct: false,
      value: "",
    },
    {
      quest_id: 1,
      is_correct: false,
      value: "",
    },
  ],
};

const QuestionIncludeForm = ({ data, errorData: errorForm, isActive, isDuplicate }, ref) => {
  const [fields, setFields] = useState([JSON.parse(JSON.stringify(TEMP_OBJ))]);
  const [errorData, setErrorData] = useState({});
  const [variants, setVariants] = useState([]);
  const { id } = useParams();
  useImperativeHandle(ref, () => ({
    isValid() {
      return validateData();
    },
    resetData() {
      setFields([JSON.parse(JSON.stringify(TEMP_OBJ))]);
    },
    getData() {
      return fields;
    },
    setData(data) {
      const updatedData = [...data]?.map((question) => ({
        ...question,
        options: question?.options?.map((option, index) => ({
          ...option,
          quest_id: index,
        })),
      }));
      setFields(updatedData);
    },
  }));
  
  const validateData = (index, type) => {
    const errors = {};
    fields.forEach((val, index) => {
      const err = {};
      const required = [
        "reward_points",
        "question",
        "description",
        // "question_images",
      ];
      if (!id) {
        required?.push("question_images");
      }
      required.forEach((key) => {
        if (key === "question" || key === "description") {
          if (!val[key]?.trim()) {
            err[key] = true;
          }
        } else {
          if (!val[key]) {
            err[key] = true;
          }
        }
      });
      if (val?.options?.length > 0) {
        val?.options.forEach((key, index) => {
          if (!key?.value?.trim()) {
            err["value_" + index] = true;
          }
        });
      }
      const correctOpt = val?.options?.some((val) => val?.is_correct === true);
      if (!correctOpt) {
        SnackbarUtils.error("Please choose the correct option");
        err["is_correct"] = true;
      }
      if (Object.keys(err)?.length > 0) {
        errors[index] = err;
      }
    });

    setErrorData(errors);
    return !(Object.keys(errors).length > 0);
  };
  useEffect(() => {
    if (data) {
      setFields({ ...data });
    }
  }, [data]);

  const removeErrors = useCallback(
    (index, key) => {
      const errors = JSON.parse(JSON.stringify(errorData));
      if (errors[index] != undefined) {
        if (Array.isArray(key)) {
          key.forEach((k) => {
            delete errors[index][k];
          });
        } else {
          delete errors[index][key];
        }
        setErrorData(errors);
      }
    },
    [setErrorData, errorData]
  );

  const changeData = (index, data, options) => {
    const tempData = [...fields];
    if (options) {
      const updatedOptions = tempData[index]?.options.map((option) => {
        if (option?.quest_id === data?.quest_id) {
          return { ...option, ...data };
        } else
          return {
            ...option,
            is_correct: data?.is_correct ? false : option?.is_correct,
          };
      });
      tempData[index] = { ...tempData[index], options: updatedOptions };
    } else {
      tempData[index] = { ...tempData[index], ...data };
    }
    // console.log(data)
    LogUtils.log("data", data);
    setFields(tempData);
    const errArr = [];
    Object.keys(data).forEach((key) => {
      errArr.push(key);
    });
    removeErrors(index, errArr);
  };

  const onBlur = useCallback(() => {}, []);

  const handleRemoveOption = async (index = 0, optionId) => {
    LogUtils.log("type", index, optionId);
    const oldState = [...fields];
    const updatedOptions = oldState[index]?.options?.filter(
      (option) => option?.quest_id !== optionId
    );

    oldState[index] = { ...oldState[index], options: updatedOptions };
    setFields(oldState);
  };

  const addOption = (index) => {
    const tempData = [...fields];
    const uniqueId =
      tempData[index]?.options[tempData[index]?.options?.length - 1]?.quest_id;

    const newOption = {
      quest_id: uniqueId + 1,
      is_correct: false,
      value: "",
    };

    tempData[index].options.push(newOption);
    setFields(tempData);
  };

  const handlePress = async (type, index = 0) => {
    LogUtils.log("type", type, index);
    const oldState = [...fields];
    if (type == "ADDITION") {
      oldState.push(TEMP_OBJ);
    } else {
      if (oldState.length === 1) {
        return true;
      }
      oldState.splice(index, 1);
    }
    LogUtils.log("oldState", oldState);
    setFields(oldState);
    // validateData();
  };
  const renderFields = useMemo(() => {
    return fields.map((val, index) => {
      const tempFilters = variants.filter((variant) => {
        const index = fields.findIndex((val) => val?.sku?.sku === variant?.sku);
        return index < 0;
      });
      return (
        <div>
          <QuestionIncludeFields
            variants={tempFilters}
            validateData={validateData}
            errors={index in errorData ? errorData[index] : null}
            changeData={changeData}
            handlePress={handlePress}
            data={val}
            index={index}
            onBlur={onBlur}
            fieldLendth={fields?.length}
            handleRemoveOption={handleRemoveOption}
            addOption={addOption}
            isActive={isActive}
            isDuplicate={isDuplicate}
          />
        </div>
      );
    });
  }, [
    variants,
    errorData,
    validateData,
    changeData,
    handlePress,
    onBlur,
    fields,
    setErrorData,
    isActive,
    isDuplicate
  ]);
  return <>{renderFields}</>;
};

export default forwardRef(QuestionIncludeForm);
